import React, { useEffect, useContext } from 'react'
import { NotificationManager, NotificationContainer } from 'react-notifications'
import notificacoesRepository from './NotificacoesRepository'
import { AuthContext } from 'elentari'
import { secondsToStringTimer } from '../../utils/Formatter'
import { useHistory } from 'react-router-dom'

const NotificacaoTempoEnum = {
  TEMPOLIMITE: 2,
  PRETEMPOLIMITE: 1
}

const NotificacoesAnalista = () => {
  const { user } = useContext(AuthContext)
  const history = useHistory()
  useEffect(() => {
    if (user.realm === 'analista' || user.realm === 'analista_2') {
      const interval = setInterval(async () => {
        const response = await notificacoesRepository.notificacoesAnalista(
          user.id
        )
        if (response.ok) {
          response.data.forEach(solicitacao => {
            if (
              solicitacao.notificacao === NotificacaoTempoEnum.PRETEMPOLIMITE
            ) {
              NotificationManager.warning(
                `Solicitação #${solicitacao.solicitacaoId} quase estourando tempo limite!`,
                `Tempo total: ${secondsToStringTimer(solicitacao.tempoTotal)}`,
                6000,
                () => {
                  history.push(`/solicitacoes/${solicitacao.solicitacaoId}`)
                }
              )
            }
            if (solicitacao.notificacao === NotificacaoTempoEnum.TEMPOLIMITE) {
              NotificationManager.warning(
                `Solicitação #${solicitacao.solicitacaoId} passou do tempo limite!`,
                `Tempo total: ${secondsToStringTimer(solicitacao.tempoTotal)}`,
                6000,
                () => {
                  history.push(`/solicitacoes/${solicitacao.solicitacaoId}`)
                }
              )
            }
          })
        }
      }, 1000 * 30)
      return () => clearInterval(interval)
    }
  }, [user.id, user.realm, history])
  return <NotificationContainer />
}

export default NotificacoesAnalista
